import { render, staticRenderFns } from "./skeleton.vue?vue&type=template&id=5bd480d4&"
import script from "./skeleton.vue?vue&type=script&lang=ts&"
export * from "./skeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd480d4')) {
      api.createRecord('5bd480d4', component.options)
    } else {
      api.reload('5bd480d4', component.options)
    }
    module.hot.accept("./skeleton.vue?vue&type=template&id=5bd480d4&", function () {
      api.rerender('5bd480d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/skeleton.vue"
export default component.exports